<template>
  <div class="page-profile-edit">

    <el-form ref="form" :model="form" :rules="rules" label-width="150px" :label-position="labelPosition">
      <el-row :gutter="50">
        <el-col :span="12" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="Bodega">
            <el-input v-model="form.sucursal" disabled />
          </el-form-item>
          <el-form-item label="Nombre" prop="name">
            <el-input v-model="form.name" />
          </el-form-item>
          <el-form-item label="Email" prop="email">
            <el-input v-model="form.email" type="email" disabled />
          </el-form-item>
          <el-form-item label="Credenciales" prop="credentials">
            <el-select v-model="form.credentials" value-key="id" multiple placeholder="Seleccione" disabled>
              <el-option v-for="item in credentials" :key="item.id" :label="item.name" :value="item"></el-option>
            </el-select>

            <el-link icon="el-icon-edit" @click="changePassword = true" v-if="edit">Actualizar Contraseña</el-link>
          </el-form-item>
          <template v-if="!edit || changePassword">
            <el-form-item label="Contraseña" prop="password">
              <el-input type="password" v-model="form.password" autocomplete="off" placeholder="Ingrese la contraseña"
                clearable></el-input>
            </el-form-item>
            <el-form-item label="Confirmar Contraseña" prop="checkPass">
              <el-input type="password" v-model="form.checkPass" autocomplete="off" placeholder="Repita la contraseña"
                clearable></el-input>
            </el-form-item>
          </template>
        </el-col>
        <el-col :span="12" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <!-- <div class="avatar"><img :src="baseUrl + 'images/avatar.png'" alt="avatar"></div> -->
        </el-col>
      </el-row>



      <el-col class="col-p">
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')" :loading="loading" icon="el-icon-check"
            v-if="!edit">Guardar</el-button>
          <el-button type="warning" @click="submitForm('form')" :loading="loading" icon="el-icon-edit"
            v-else>Actualizar</el-button>
        </el-form-item>
      </el-col>
    </el-form>
  </div>
</template>

<script>
import store from '@/store'
import {
  update,
  getById,
  credentials,
} from "@/api/user";
import { removeUser, setUser } from "@/utils/auth";
export default {
  name: 'ProfileEdit',
  props: ['user'],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Porfavor ingrese la contraseña"));
      } else {
        if (this.form.checkPass !== "") {
          this.$refs.form.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Porfavor repita la contraseña"));
      } else if (value !== this.form.password) {
        callback(new Error("Las contraseñas no coinciden!"));
      } else {
        callback();
      }
    };
    return {
      baseUrl: process.env.VUE_APP_ROOT,
      changePassword: false,
      loading: false,
      form: {
        id: this.user.id,
        sucursal_id: this.user.branch.id,
        sucursal: this.user.branch.razon_social,
        name: this.user.name,
        email: this.user.email,
        credentials: this.user.roles,
        password: "",
        checkPass: "",
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        name: [
          {
            required: true,
            message: "Porfavor ingrese el nombre",
            trigger: "blur",
          },
        ],
      },
      credentials: [],
      labelPosition: 'top',
      edit: true
    }
  },
  methods: {
    submitForm(formName) {
      this.loading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.edit) {
            this.updateForm();
          } else {
            // this.saveForm();
          }
        } else {
          this.loading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    updateForm() {
      let me = this
      update(this.form)
        .then(({ data }) => {
          this.loading = false;
          if (data.code === 200) {
            this.$message.success("Actualización exitosa!")
            this.getUserById();
            this.changePassword = false
          } else {
            this.$message.error("Error! " + data.error);
          }
        })
        .catch(function (error) {
          me.loading = false;
          console.log("Err: ", error);
        });
    },
    getUserById() {
      let me = this
      getById(this.form.id)
        .then(({ data }) => {
            removeUser()
            me.form = {
              id: data.id,
              sucursal: data.branch.razon_social,
              sucursal_id: data.branch.id,
              name: data.name,
              email: data.email,
              credentials: data.roles,
            };
            setTimeout(() => {
              setUser(JSON.stringify(data));
              store.commit('setUserSession')
            }, 1000);
        })
        .catch(function (error) {
          me.loading = false;
          console.log("Err: ", error);
        });
    },

    getCredentials() {
      credentials()
        .then(({ data }) => {
          this.credentials = data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onSubmit() {
      console.log('submit!');
    },
    resizeLabelPosition() {
      if (window.innerWidth <= 768) {
        this.labelPosition = 'top'
      }
    }
  },
  mounted() {
    this.getCredentials();
    this.resizeLabelPosition();
    window.addEventListener('resize', this.resizeLabelPosition);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeLabelPosition);
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.page-profile-edit {
  .avatar {
    background-color: white;
    border: 6px solid #fff;
    bottom: 10px;
    width: 180px;
    height: 180px;
    overflow: hidden;
    border-radius: 50%;
    box-sizing: border-box;
    box-shadow: 0px 20px 15px -15px rgba(0, 0, 0, 0.15);

    img {
      width: 100%;
    }
  }

  .label-switch-box {
    display: block;
    clear: both;
    width: 100%;
    text-align: right;
    margin-bottom: 20px;
  }

  .col-p {
    margin-top: 10px;
    padding: 0px;
    box-sizing: border-box;
  }

  .select-wide {
    width: 100%;
  }
}
</style>
